import React from "react";
import { ToastContainer, toast, ToastOptions } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IoIosCheckmarkCircle, IoMdCloseCircle } from "react-icons/io";

interface ToastProps {}

const Toast: React.FC<ToastProps> = () => {
  const defaultOptions: ToastOptions = {
    position: "top-right", 
    autoClose: 2000, 
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  };

  const containerStyle = {
    marginTop: "20px",
    marginRight: "auto",
    marginLeft: "auto",
    width: "400px",
  };

  return (
    <>
      <ToastContainer
        {...defaultOptions}
        style={containerStyle}
        className="toast-message-container mt-5 mx-auto w-[400px]"
        limit={1}
      />
    </>
  );
};

export const showToast = (
  message: string | undefined,
  status: boolean,
  options?: ToastOptions & { includeLoginLink?: boolean }
) => {
  const defaultSuccessMessage = "Operation successful";
  const defaultErrorMessage = "Operation failed";

  const ToastMessage = ({ message }: { message: string }) => (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-start flex-1">
        {status ? (
          <IoIosCheckmarkCircle
            size={20}
            className="text-[#10B981] mr-3 shrink-0"
          />
        ) : (
          <IoMdCloseCircle
            size={20}
            className="text-[#EF4444] mr-3 shrink-0"
          />
        )}
        <div>
          <p className="text-sm text-[#6B7280] m-0">
            {message || (status ? defaultSuccessMessage : defaultErrorMessage)}
          </p>
        </div>
      </div>

      <div className="flex flex-col justify-center gap-1">
        {options?.includeLoginLink && (
          <a href="/signin" className="block text-xs font-medium text-[#0A7BCE]">
            Log In
          </a>
        )}
        {/* Close Button */}
        <button className="text-[#4B5563] text-xs font-medium">Close</button>
      </div>
    </div>
  );

  const toastOptions: ToastOptions = {
    className: status ? "toast-success" : "toast-error",
    style: {
      backgroundColor: "white",
      borderRadius: "12px",
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      padding: "16px",
      minHeight: "unset",
      color: "#1F2937",
      width: "400px",
    },
    ...options,
  };

  toast(
    <ToastMessage
      message={
        message || (status ? defaultSuccessMessage : defaultErrorMessage)
      }
    />,
    toastOptions
  );
};

export default Toast;